class QuickAddModal {

constructor(){

this.modal = document.getElementById("QuickAddModal")
this.content = document.getElementById("QuickAddModalContent")

if(!this.modal || !this.content) return

// placer le modal directement dans <body>
document.body.appendChild(this.modal)

this.bindEvents()

}

bindEvents(){

document.body.addEventListener("click", this.open.bind(this))
document.body.addEventListener("click", this.close.bind(this))
document.addEventListener("keydown", this.escClose.bind(this))

}

async open(e){

const btn = e.target.closest("[data-quick-add]")
if(!btn) return

e.preventDefault()

const productUrl = btn.dataset.productUrl
if(!productUrl) return

try {

// ouvre le modal
this.modal.classList.add("active")
this.modal.style.display = "flex"

// charge la section produit Dawn
const response = await fetch(productUrl + "?section_id=main-product")
const html = await response.text()

// injecte la section dans le modal
this.content.innerHTML = html

} catch(error){

console.error("Quick Add modal error:", error)

}

}

close(e){

if(!e.target.closest("[data-modal-close]")) return

this.modal.classList.remove("active")
this.modal.style.display = "none"

this.content.innerHTML = ""

}

escClose(e){

if(e.key === "Escape"){

this.modal.classList.remove("active")
this.modal.style.display = "none"
this.content.innerHTML = ""

}

}

}

document.addEventListener("DOMContentLoaded", () => {
new QuickAddModal()
})